export default __webpack_public_path__ + "static/media/realme.eaa1b80c.jpg";